import { render, staticRenderFns } from "./Curtain.vue?vue&type=template&id=11137d48&scoped=true&"
import script from "./Curtain.vue?vue&type=script&lang=js&"
export * from "./Curtain.vue?vue&type=script&lang=js&"
import style0 from "./Curtain.vue?vue&type=style&index=0&id=11137d48&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11137d48",
  null
  
)

export default component.exports